<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row ">
            <div class="contact-form col-lg-6">
                            <div v-if="validationErrors">
                        <ul class="alert alert-danger" style="list-style: none;">
                            <li v-for="(value, key, index) in validationErrors" v-bind:key="index">{{ value[0] }}</li>
                        </ul>
              </div>
              <form id="contact" @submit="checkForm" action="#" method="post">

                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >মোবাইল নাম্বার<span class="required">*</span></label
                  >
                  <input
                    class="form-control"
                    id="exampleInputEmail1"
                    name="mobile"
                    v-model="formData.mobile"
                    aria-describedby="emailHelp"
                    placeholder=" আপনার মোবাইল নাম্বার এখানে লিখুন"
                  />
                </div>

                <div class="form-group">
                  <label for="exampleInputPhone">
                    পাসওয়ার্ড<span class="required">*</span></label
                  >
                  <input
                       autocomplete="off"
                    type="password"
                    class="form-control"
                    name="phone"
                    v-model="formData.password"
                    placeholder=" আপনার পাসওয়ার্ড এখানে দিন"
                  />
                </div>

                <button type="submit" class="btn btn-primary">লগইন</button>

                <div class="mt-2">
                  <router-link :to="{name: 'forgotpassword'}"
                    >পাসওয়ার্ড ভুলে গেছেন?</router-link
                  >
                </div>
                <div>
                  <router-link :to="{ name: 'signup'}"
                    >অ্যাকাউন্ট নেই? এখনই সাইন আপ করুন!
                    </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `login`,
  components: {
    Layout
  },
  data() {
    return {
      errors: [],
      validationErrors: null,
      formData: {
        mobile: null,
        password: null,
        redirectUrl: localStorage.getItem("redirectUrl")
      }
    };
  },
  methods: {
    checkForm: function(e) {
      e.preventDefault();

      if (!this.formData.mobile) {
        this.flashMessage.error({
          message: "আপনার মোবাইল নাম্বার লিখুন"
        });
        return false;
      }

      if (!this.formData.password) {
        this.flashMessage.error({ message: "আপনার পাসওয়ার্ড লিখুন" });
        return false;
      }

      console.log(this.formData);
      this.$http
        .post("login", this.formData)
        .then(response => {
          if (response.data.status) {
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("user_id", response.data.user.id);
            localStorage.setItem("name", response.data.user.name);
            localStorage.setItem("mobile", response.data.user.mobile);
            localStorage.setItem("email", response.data.user.email);
            if (this.redirectUrl) {
                location.href = this.redirectUrl;
              } else {
                if(response.data.user.role_id == 3){
                      window.location.href = 'customer/dashboard/profile';
                }else{
                      window.location.href = 'merchant/dashboard/profile';
                }
              }
          } else {
            this.flashMessage.error({
              message: response.data.message
            });
          }
        })
        .catch(error => {
          if (error.response.status == 422 || error.response.status == 401){
             this.flashMessage.error({
              message: 'Please try again later.'
            });
            }
        })

    }
  },
  mounted(){
    this.redirectUrl = localStorage.getItem("redirectUrl");
  }
};
</script>
